import Questions from '~/lib/Questions';
import { FC } from 'react';
import type {
  FormQuestion,
  FormAnswer as FormAnswerType,
} from '~/lib/Api.types';
import FormAnswer from './FormAnswer';

type FormAnswersProps = {
  answers: Array<{
    question: FormQuestion;
    answer: FormAnswerType;
  }>;
};
const FormAnswers: FC<FormAnswersProps> = ({ answers }) => {
  return (
    <div>
      {answers
        .filter(a => !Questions[a.question.type]?.excludeFromAnswers)
        .map((answerData, idx) => (
          <div
            className={`my-2 ${idx > 0 ? 'mt-4' : ''}`}
            key={answerData.question.id}
          >
            <div className="label">
              {answerData.question.label ||
                Questions[answerData.question.type]?.name ||
                'No label'}
            </div>
            <div>
              <FormAnswer
                answer={answerData.answer.answer}
                question={answerData.question}
              />
            </div>
          </div>
        ))}
      {answers.length === 0 && <div>There are no answers to the form</div>}
    </div>
  );
};

export default FormAnswers;
